/* global wx */
import Vue from 'deps/vue';
import { setAuth } from 'helper/configAuth';
import fectx from 'helper/fectx';
import fectxAlt from 'helper/fectxAlt';
import { isWeChat } from 'helper/env';
import { getConfig } from 'helper/configManager';
import { parseQueryString, makeUrl } from 'utils/url';
import Message from 'base-components/Message';
import statistic from './statistic';
import BindPhoneDialog from '../../components/BindPhoneDialog';
import './common';

const TOKEN_PERSISTENT_KEY = 'pintuan.user_token';

const config = getConfig();

const queryStr = parseQueryString(window.location.search);

let isReady = false;
let bindPhoneCb;
let readyCallback;
let token; // undefine 代表还不知道 token 的值是什么, 需要先获取; null 代表 token 值就是 null
let bindPhonePop;

function setUp(cfg) {
  // 返回了数字签名对象
  // 开始配置微信JS-SDK
  wx.config({
    debug: process.env.NODE_ENV === 'development',
    appId: cfg.appId,
    timestamp: cfg.timestamp,
    nonceStr: cfg.nonceStr,
    signature: cfg.signatrue,
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'hideMenuItems',
      'chooseWXPay',
    ],
  });

  // 调用微信API
  wx.ready(() => {
    isReady = true;
    if (readyCallback) {
      readyCallback();
    }
  });
}

async function configWeChat() {
  let resp;
  try {
    resp = await fectx.get('/wechat/config', {
      params: {
        url: window.location.href.split('#')[0], // 将当前URL地址上传至服务器用于产生数字签名
      },
    });
  } catch (_error) {
    // ingore
  }
  const data = resp.data;
  // eslint-disable-next-line eqeqeq
  if (data.ResultCode != 200) {
    return;
  }
  setUp(data.InnerData);
}

function wxAuth(_cb, returnUrl) {
  if (process.env.NODE_ENV === 'development' && !isWeChat) {
    return;
  }

  const _url = returnUrl || window.location.href.split('#')[0];
  const stripSpecParams = _url
    .replace(/ucode=[^&]+/gi, '')
    .replace(/source[iI]d=[^&]+/gi, '');
  const url = makeUrl(stripSpecParams, {
    /* hack */ _r: 'hack',
    sourceid: config.sourceId,
  });

  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    config.wxAppId
  }&redirect_uri=${window.location.protocol.replace(':', '')}%3a%2f%2f${
    config.wxAuthHost
  }%2fwechat%2fv1%2foauth2%3freturnurl%3d${encodeURIComponent(
    url
  )}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
}

async function initUserInfo(ucode) {
  let resp;
  try {
    resp = await fectx.get(`/wechat/${ucode}/OAuthInfo`);
  } catch (error) {
    Message.error('网络错误');
  }

  const data = resp.data;
  // eslint-disable-next-line eqeqeq
  if (data.ResultCode != '200') {
    Message.error(data.InnerData);
  }
  const payload = data.InnerData;
  if (!payload) {
    // ucode 过期
    wxAuth();
  }

  setToken(payload.Token);
}

function setToken(value) {
  token = value;
  localStorage.setItem(TOKEN_PERSISTENT_KEY, token);
  setAuth('ustr', token);
}

function clearToken() {
  localStorage.removeItem(TOKEN_PERSISTENT_KEY);
  token = null;
}

export function getToken() {
  if (token === undefined) {
    token = localStorage.getItem(TOKEN_PERSISTENT_KEY);
  }

  return token;
}

export async function init() {
  console.log('in wechat');
  fectx.interceptors.response.use(response => {
    if (
      // eslint-disable-next-line eqeqeq
      response.status == '403' &&
      response.data &&
      response.data.InnerData === '用户信息无效'
    ) {
      logout();
      wxAuth();
    }

    return response;
  });

  let initPromise;

  const token = getToken();
  const hasToken = token !== undefined && token !== null && token !== '';
  if (hasToken) {
    setToken(token);
    initPromise = configWeChat();
  } else if (queryStr.ucode) {
    initPromise = Promise.all([initUserInfo(queryStr.ucode), configWeChat()]);
  } else {
    wxAuth();
    return;
  }

  try {
    await initPromise;
  } catch {
    // ignore error
  } finally {
    statistic(4);
  }
  return;
}

export function bindPhone(cb) {
  // 微信里必须登录过才能访问页面, 所以总是 true
  bindPhoneCb = cb;

  if (!bindPhonePop) {
    const DialogConstructor = Vue.extend(BindPhoneDialog);
    // const div = document.createElement('div');
    bindPhonePop = new DialogConstructor({
      propsData: {
        title: '请先登录你的账户',
        sourceId: config.sourceId,
      },
      _parentListeners: {
        success(userInfo) {
          bindPhonePop.visible = false;
          setToken(userInfo.Token);

          if (bindPhoneCb) {
            bindPhoneCb(userInfo);
          }
        },
        'update:visible'(visible) {
          bindPhonePop.visible = visible;
        },
      },
    });
    bindPhonePop.$mount();
  }

  bindPhonePop.visible = true;
}

export function isLogin() {
  // 微信里必须登录过才能访问页面, 所以总是 true
  return true;
}

export function login() {
  throw new Error('wx.login should never be called!');
}

export function setTitle(title) {
  document.title = title;
}

export function setShareData({
  title,
  description,
  imageUrl,
  url,
  onSuccess,
} = {}) {
  const shareData = {
    title: title ? title : document.title,
    desc: description,
    link: url ? url : window.location.href.split('#')[0],
    imgUrl: imageUrl,
    success() {
      if (onSuccess) {
        onSuccess();
      }
    },
    cancel() {
      // alert('用户取消分享后执行的回调函数');
    },
  };

  if (isReady) {
    wx.onMenuShareTimeline(shareData); // 分享到朋友圈
    wx.onMenuShareAppMessage(shareData); // 分享给朋友
    wx.onMenuShareQQ(shareData); // 分享到QQ
    wx.onMenuShareWeibo(shareData); // 分享到微博
  } else {
    readyCallback = () => {
      wx.onMenuShareTimeline(shareData); // 分享到朋友圈
      wx.onMenuShareAppMessage(shareData); // 分享给朋友
      wx.onMenuShareQQ(shareData); // 分享到QQ
      wx.onMenuShareWeibo(shareData); // 分享到微博
    };
  }
}

export function shareUrl(before) {
  statistic(3);
  if (before) {
    before();
  }
}

export function logout() {
  clearToken();
}

export function gotoUrl(url, { withEnv = true } = {}) {
  if (withEnv) {
    window.location.href = makeUrl(url, { sourceid: config.sourceId });
  } else {
    window.location.href = url;
  }
}

export function mock(si) {
  setToken(si);
}

// 独有
export async function choosePay({ id, code } = {}) {
  let resp;
  try {
    Message.success('请求支付中', {
      timeout: 0,
    });
    resp = await fectxAlt.get(`/pay/${id}/${code}/unified`, {
      timeout: 10 * 1000,
    });
    Message.hide();
  } catch (error) {
    Message.error('网络错误');
    return;
  }
  const data = resp.data;
  // eslint-disable-next-line eqeqeq
  if (data.ResultCode != '200') {
    Message.error(data.InnerData || resp.statusText);
    return;
  }
  const payload = data.InnerData;

  // const payload = {
  //   nonceStr: '4e9d6c209e1b429eaf0963a7132b8a1f',
  //   package: 'prepay_id=wx091401505259460bb3b82e003718773014',
  //   paySign: '12CCEA41AD477870E4D399FCA7028C30',
  //   signType: 'MD5',
  //   timestamp: '1557381711',
  // };
  return new Promise(resolve => {
    wx.chooseWXPay({
      ...payload.PayData,
      success() {
        resolve(true);
      },
      fail() {
        resolve(false);
      },
      cancel() {
        resolve(false);
      },
    });
  });
}
